export const parsePNRs = (pnrs) => pnrs.split(",").map((p) => p.trim());

export const validatePNRs = (pnrs) => pnrs.every((p) => p.length === 6);
